<template>
  <custom-dialog appendToBody width="1250px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="item-title">{{ $t('fms_invoice_gored_select_dialog.xzxhcdqzd') }}</div>
      <div class="search-hd" style="margin-top: -22px" v-if="!model.invoiceId">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0">
            <search-input v-model="formSearch.keyword" :placeholder="$t('fms_invoice_gored_select_dialog.htbhjsh')" @fetch="getTableList({ page: 1 })"></search-input>
          </el-form-item>
          <!-- 更多搜索 -->
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('fms_invoice_gored_select_dialog.fu_kuan_dao_qi_ri_qi')">
            <custom-date-picker
              style="width: 100%"
              v-model="formSearch.billPaymentTime"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :key="billPaymentTimeKey"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('fms_invoice_gored_select_dialog.qi_hao')">
            <el-input v-model="formSearch.termNum" :placeholder="$t('fms_invoice_gored_select_dialog.zhi_chi_qu_jian_ru25')" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('fms_invoice_gored_select_dialog.fa_piao_hao_ma')">
            <el-input :placeholder="$t('fms_invoice_gored_select_dialog.fa_piao_hao_ma')" v-model="formSearch.invoiceNum" clearable></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <custom-table default-expand-all expand tableCode="invoiceGoRedSelect" :data="billList" @filter="filterChange" @sort="sortChange">
        <template slot="expand" slot-scope="scope" v-if="scope.row.billList.length">
          <custom-table
            :ref="'tb' + scope.$index"
            type="checkbox"
            :selectable="row => isRowSelectable(row, scope.row)"
            @selection-change="val => setCheckBoxAll(val, scope.row)"
            v-model="scope.row.selected"
            tableCode="invoiceGoRedMonth"
            :data="scope.row.billList"
          ></custom-table>
        </template>
      </custom-table>
      <div class="table-page">
        <div style="float: left; overflow: hidden; padding-top: 6px; padding-left: 12px">
          <el-checkbox :indeterminate="indeterminate" v-model="checkedAll" @change="onCheckBoxAll">{{ $t('Common.com_sel_all')}}</el-checkbox>
        </div>
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" :disabled="!isSubmit" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import commonMixin from '@/pages/fms/mixins/commonMixin';
import mixins from '@/pages/fms/components/mixins';

export default {
  mixins: [dialogMixins, commonMixin, mixins],
  data() {
    return {
      billList: [],
      totalRows: 0,
      formSearch: {
        keyword: '',
        termNum: '',
        invoiceNum: '',
        billPaymentTime: [],
        pageNum: 1,
        pageSize: 20,
      },
      indeterminate: false,
      checkedAll: false,
      billPaymentTimeKey: 1,
      lockSelectionTimer: null,
      lockAllBillList: false,
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
  },
  computed: {
    isSubmit: vm => vm.billList.filter(t => t.selected && t.selected.length).length > 0,
  },
  methods: {
    // 全选事件1
    setCheckBoxAll() {
      if (this.lockAllBillList) {
        this.syncLockTableSelection();
      }
      const idx = this.billList.findIndex(t => t.billList.length > 0 && t.selected.length !== t.billList.length);
      this.checkedAll = idx === -1;
      const has = this.billList.findIndex(t => t.selected.length > 0);
      this.indeterminate = has !== -1 && !this.checkedAll;
    },
    // 全选事件2
    onCheckBoxAll(value) {
      for (let i = 0; i < this.billList.length; i++) {
        if (this.$refs[`tb${i}`]) {
          if (value || this.lockAllBillList) {
            this.$refs[`tb${i}`].$emit('clearSelection');
            this.billList[i].billList.forEach(item => {
              this.$refs[`tb${i}`].$emit('toggleRowSelection', item, true);
            });
          } else {
            this.$refs[`tb${i}`].$emit('clearSelection');
          }
        }
      }
      if (this.lockAllBillList) {
        this.checkedAll = true;
        this.indeterminate = false;
      }
    },
    // 初始化
    getTableList: function () {
      const termNum = this.formSearch.termNum;
      // 是否为纯数字的字符串
      const testPureNum = /^\d+$/;
      // 是否为 1-3 格式的字符串
      const testRangeNum = /^\d+\-\d+$/;
      if (termNum) {
        const isPureNum = testPureNum.test(termNum);
        const isRangeNum = testRangeNum.test(termNum);
        if (!isPureNum && !isRangeNum) {
          this.$message.error(this.$t('fms_invoice_gored_select_dialog.qsrhfqh'));
          return;
        }
      }
      // 发票管理已开票
      if (this.model.invoiceId) {
        this.$getJSON(`${apis.invoiceBlueGoRedBillList}/${this.model.invoiceId}`, this.formSearch).then(async (res) => {
          // const list = res.data;
          // this.billList = await this.formatBillList(list);
          const list = res.data.records;
          this.billList = await this.formatBillList(list);
          this.totalRows = res.data.total;
        });
        return;
      }
      const obj = {};
      if (this.model.billId) {
        obj.billId = this.model.billId;
      } else {
        obj.payableOrgId = this.model.payableOrgId;
      }
      obj.buyerNumber = this.model.buyerNumber;
      this.$getJSON(apis.invoiceGoRedBill, Object.assign(obj, this.formSearch, { termNum: this.formatTermNum(this.formSearch.termNum) })).then(async (res) => {
        const list = res.data.records;
        this.billList = await this.formatBillList(list);
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.billPaymentTime = '';
      // 然后日期组件重新根据init-value赋值
      this.billPaymentTimeKey++;
      setTimeout(() => {
        this.onPageChange({ page: 1 });
      }, 300);
    },
    // 数据监听预处理
    async formatBillList(billList) {
      const billMonthIds = this.model.billMonthIds || [];
      const result = await Promise.all(billList.map(row => this.$getJSON(`${apis.invoiceMonthBill}/${row.billId}`)));
      billList.forEach((item, i) => {
        const list = result[i].data || [];
        const currentBillList = list.filter(t => !billMonthIds.includes(t.billMonthId));
        billList[i]['billList'] = currentBillList;
        billList[i]['selected'] = [];
      });
      this.lockAllBillList = billList.some(row => this.hasLockBillType(row.billList));
      if (this.lockAllBillList) {
        billList.forEach((row) => {
          row.selected = [...row.billList];
        });
      }
      this.syncLockTableSelection();
      setTimeout(() => {
        this.syncLockTableSelection();
        this.setCheckBoxAll();
      }, 500);
      return billList;
    },
    // 当前子表格是否包含锁定账单
    hasLockBillType(list = []) {
      return list.some(t => Number(t.billType) === 19);
    },
    // 锁定行不可取消选择
    isRowSelectable() {
      return !this.lockAllBillList;
    },
    // 同步锁定子表格的默认全选状态
    syncLockTableSelection() {
      clearTimeout(this.lockSelectionTimer);
      this.lockSelectionTimer = setTimeout(() => {
        this.billList.forEach((row, i) => {
          if (this.$refs[`tb${i}`] && this.lockAllBillList) {
            row.billList.forEach(item => {
              this.$refs[`tb${i}`].$emit('toggleRowSelection', item, true);
            });
            row.selected = [...row.billList];
          }
        });
        if (this.lockAllBillList) {
          this.checkedAll = true;
          this.indeterminate = false;
        }
      }, 0);
    },
    // 确认保存
    confirm: function () {
      this.visible = false;
      let list = this.billList.filter(t => t.selected && t.selected.length);
      list = list.reduce((pre, item) => [...pre, ...item.selected.map(t => Object.assign({}, item, t))], []);
      this.$nextTick(() => {
        this.$emit('success', list);
      });
    },
  },
};
</script>

<style lang="scss"></style>
